import React, { useEffect, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { get, post, put, del, api } from "../../../utils/api";
import Cards from "../../../Components/Common/Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import ActionButtons from "../../../Components/Common/ActionButtons";
import ViewData from "./ViewData";
import Form from "./Form";
import { Alert, Snackbar } from "@mui/material";
import DeleteAlertDialog from "../../../Components/Masters/DeleteAlertDialog";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";

const EOLTreatmentOfSoldProducts = () => {
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [deletedItemId, setDeletedItemId] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [filters, setFilters] = useState({
    productName: [],
    endOfLifeTreatmentMethod: [],
  });

  const [cardData, setCardData] = useState({
    totalRecords: 0,
    topProductName: [],
    disposalMethodQuantities: {
      quantityByIncineration: 0,
      quantityByRecycling: 0,
      quantityByLandfilling: 0,
    },
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const headers = [
    { key: "createdAt", label: "Date", sortable: true },
    { key: "productName", label: "Product Name", sortable: true },
    {
      key: "endOfLifeTreatmentMethod",
      label: "EOL Treatment Method",
      sortable: true,
    },
    { key: "numberOfUnitsSold", label: "Number of Units Sold", sortable: true },
    { key: "dataSource", label: "Data Source", sortable: true },
  ];

  const inputData = [
    { fieldName: "productName", title: "Product Name" },
    { fieldName: "eolMonth", title: "Production Month" },
    {
      fieldName: "endOfLifeTreatmentMethod",
      title: "End-of-Life Treatment Method",
    },
    {
      fieldName: "averageWeightPerUnit",
      title: "Average Weight per Unit (MT)",
    },
    { fieldName: "numberOfUnitsSold", title: "Number of Units Sold" },
    { fieldName: "dataSource", title: "Data Source" },
    { fieldName: "remark", title: "Remarks" },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Product Name",
      type: "option",
      key: "productName",
      value: filters?.productName || [],
    },
    {
      title: "EOL Treatment Method",
      type: "option",
      key: "endOfLifeTreatmentMethod",
      value: filters?.endOfLifeTreatmentMethod || [],
    },
  ];

  const bannerData = [
    {
      title: "Quantity of waste treated by inceneration",
      description: `${
        cardData?.disposalMethodQuantities?.quantityByIncineration ?? 0
      }`,
    },
    {
      title: "Quantity of waste treated by recycling",
      description: `${
        cardData?.disposalMethodQuantities?.quantityByRecycling ?? 0
      }`,
    },
    {
      title: "Quantity of waste treated by landfilling",
      description: `${
        cardData?.disposalMethodQuantities?.quantityByLandfilling ?? 0
      }`,
    },
  ];

  const fetchExcelData = () => {
    const template = [
      {
        "Product Name": "",
        "Production Month (MM/YYYY)": "",
        "Number of Units Sold": "",
        "Data Source": "",
        Remark: "",
      },
    ];

    setExcelData(template);
  };

  const fetchData = async () => {
    try {
      const filter = { ...filterObj };

      if (filter.createdAt) {
        filter.startDate = filter?.createdAt?.start;
        filter.endDate = filter?.createdAt?.end || new Date();
      }

      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const res = await get(
        `/scope3/eolTreatmentOfSoldProducts/get?${queryParams}`
      );

      const arr =
        res?.data?.data?.map((item) => ({
          ...item,
          action: "View",
          id: item?._id,
        })) || [];

      setTableData(arr);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage]);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/eolTreatmentOfSoldProducts/cardData`);
      const data = res?.data?.data || {};
      setCardData({
        totalRecords: data?.totalRecords || 0,
        topProductName: data?.topProductName || [],
        disposalMethodQuantities: data?.disposalMethodQuantities || {
          quantityByIncineration: 0,
          quantityByRecycling: 0,
          quantityByLandfilling: 0,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFilters = async () => {
    try {
      const res = await get(`/scope3/eolTreatmentOfSoldProducts/filter`);
      const { productName, endOfLifeTreatmentMethod } =
        res?.data?.data || {};

      setFilters({
        productName: productName || [],
        endOfLifeTreatmentMethod: endOfLifeTreatmentMethod || [],
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchExcelData();
  }, []);

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setCurrentPage(1);
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
      setEditModal(false);
      setEditData({});
    } else if (type === "edit") {
      setIsModalOpen(true);
      setEditData(dataForEdit);
      setEditModal(true);
      setViewModal(false);
    }
  };

  const handleEdit = (data) => {
    openModal("edit", data);
  };

  const openViewModal = (data) => {
    setEditData(data);
    setViewModal(true);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setIsModalOpen(false);
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (data, isEditing) => {
    try {
      const url = isEditing
        ? `/scope3/eolTreatmentOfSoldProducts/update?Id=${
            editData.id || editData._id
          }`
        : `/scope3/eolTreatmentOfSoldProducts/add`;

      const apiCall = isEditing ? put : post;

      const res = await apiCall(url, data);

      if (res) {
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });

        setIsModalOpen(false);

        if (isEditing) {
          setEditModal(false);
          setEditData({});
        }

        fetchCardData();
        fetchData();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message || "Something went wrong",
        severity: "error",
      });

      console.error("Error in handleSubmit (EOLTreatmentOfSoldProducts):", error);
    }
  };

  const handleDeleteOpen = (row) => {
    setDeletedItemId(row);
    setDeleteDialog(true);
  };

  const handleDeleteAgree = async () => {
    try {
      await del(`/scope3/eolTreatmentOfSoldProducts/delete`, {
        params: {
          Id: deletedItemId?.id || deletedItemId?._id,
        },
      });
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: "Deleted successfully",
        severity: "success",
      });
      fetchData();
      fetchCardData();
    } catch (err) {
      console.error(err);
      setsnackOpen({
        open: true,
        message: err.response?.data?.message ?? "Network Error",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Cards
        data={bannerData}
        title={"End of life treatment of sold products"}
      />

      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        filterObj={filterObj}
        onUploadClick={() => setBulkUploadModal(true)}
      />

      <ViewTable
        title={"EOL Treatment"}
        headers={headers}
        data={tableData ?? []}
        onSort={handleSort}
        sortConfig={sortConfig}
        page={currentPage}
        count={10}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onView={(row) => {
          openViewModal(row);
        }}
        onEdit={(row) => openModal("edit", row)}
        onDelete={(row) => handleDeleteOpen(row)}
      />

      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <Form
        isOpen={isModalOpen}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        header={
          editModal
            ? "Edit End of Life Treatment of Sold Product"
            : "Add End of Life Treatment of Sold Product"
        }
        initialData={editData}
        isEditing={editModal}
      />

      <ViewData
        id={editData ? editData.id || editData._id : ""}
        element={editData}
        title={"EOL Treatment Details"}
        viewData={viewModal}
        setViewData={setViewModal}
        setData={setEditData}
        inputData={inputData}
        handleEdit={handleEdit}
      />

      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: deletedItemId?.id || deletedItemId?._id,
            url: `${api}/scope3/eolTreatmentOfSoldProducts/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={() => {
            setBulkUploadModal(false);
            fetchData();
            fetchCardData();
          }}
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"eolTreatmentOfSoldProducts"}
          setsnackOpen={setsnackOpen}
          url={"/scope3/eolTreatmentOfSoldProducts/bulkupload"}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

export default EOLTreatmentOfSoldProducts;

